import { Link, UIText2 } from '@cian/ui-kit';

import * as styles from './Phone.css';

interface IProps {
  formattedPhone: string;
  hiddenPhone: string;
  isPhoneMinimized: boolean;
  onPhoneClick(): void;
}

export const Phone = ({ formattedPhone, hiddenPhone, isPhoneMinimized, onPhoneClick }: IProps) => {
  return (
    <div data-name="Phone">
      {isPhoneMinimized ? (
        <div onClick={onPhoneClick} className={styles['container']}>
          <UIText2>{`${hiddenPhone}`}</UIText2>
          <UIText2 color="text-main-default"> Показать</UIText2>
        </div>
      ) : (
        <Link fontSize="S" href={`tel:${formattedPhone}`} data-name="OpenPhone">
          {formattedPhone}
        </Link>
      )}
    </div>
  );
};
